import moment from "moment";
export function getParameterByName(e, t = window.location.href) {
  e = e.replace(/[\[\]]/g, "\\$&"); var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
  return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null;
};

export function printReceipt(orderDetails, settings, kitchens, t, formatter) {

  let printDetails = {};
  let kitchensUsed = [];
  printDetails.printType = orderDetails.printType || "receipt";

  printDetails.tokenNo = settings.bizVertical.toLowerCase() != 'retail' ? "Token #" + orderDetails.number : "";
  printDetails.merchant = settings.firstName;
  printDetails.invoiceNo = t({ id: "invoice" }) + "#:" + orderDetails.invoiceNo;
  printDetails.date = moment(orderDetails.createdAt).format(
    "DD-MMM-YYYY h:mm a"
  );
  printDetails.cashier = "Cashier: " + orderDetails.cashier;
  printDetails.header1 = t({ id: "items" });
  printDetails.header2 = t({ id: "quantity" });
  printDetails.header3 = t({ id: "amountlbl" });
  printDetails.orderItems = [];
  printDetails.receiptNote = settings.receiptNote || "";
  printDetails.logoImg = settings.logoImg || "";
  printDetails.cashOut = orderDetails.cashOut;
  printDetails.kitchens = kitchens;
  printDetails.locale = settings.locale;
  printDetails.discount = "Discount: " + formatter.format(orderDetails.discountAmount || 0).replace('JMD', 'J$').replace(/\s+/, "");
  printDetails.discountAmount = printDetails.discount;
  printDetails.isPaid = orderDetails.isPaid;
  //printDetails.currencyIcon=<CurrencySymbol/>;
  printDetails.currency = settings.currency;
  printDetails.address = settings.address;
  printDetails.customer = orderDetails.customer;
  printDetails.receiptNote = orderDetails.receiptNote;
  printDetails.orderType = orderDetails.orderType;
  printDetails.subTotal = formatter.format((orderDetails.totalPrice - orderDetails.taxPrice)).replace('JMD', 'J$').replace(/\s+/, "");
  if (orderDetails.orderType == "Table Order" && settings?.dining_service_charge) {
    printDetails['serviceCharge'] = settings.dining_service_charge;
  }
  if (orderDetails.taxPrice && orderDetails.taxPrice > 0) {
    printDetails.tax = formatter.format(orderDetails.taxPrice).replace('JMD', 'J$').replace(/\s+/, "");
  }
  printDetails.isTaxShow = orderDetails.taxPrice > 0 ? true : false;
  if (orderDetails.serviceCharge) {
    printDetails.serviceCharge =
      t({ id: "serviceCharge" }) +
      " " + formatter.format(orderDetails.serviceCharge).replace('JMD', 'J$').replace(/\s+/, "");
  }
  printDetails.total =
    t({ id: "total" }) +
    ": " + formatter.format(orderDetails.totalPrice).replace('JMD', 'J$').replace(/\s+/, "");
  printDetails.payVia = orderDetails.payVia;
  printDetails.splitPayVia = orderDetails.splitPayVia;
  printDetails.splitAmount = orderDetails.splitAmount;

  let AddorderItems =
    orderDetails &&
    orderDetails.orderItems &&
    orderDetails.orderItems.map((item, index) => {
      const subPro = item.sub_pro ? JSON.parse(item.sub_pro) : {};
      const addonNames = subPro.addons
        ?.map((a) => a.name)
        .join(",");
      const varietyNames = subPro.variety
        ? Object.keys(subPro.variety).join(",")
        : "";
      const cookInst = subPro.cookInstructions.join(',');
      item.price = formatter.format(item.price).replace('JMD', 'J$').replace(/\s+/, "");
      item.quantity = item.select_type === "weight"
        ? `${(item.quantity / 1000).toFixed(2)}K/L `
        : item.quantity;
      item.addOnsStr = addonNames;
      item.varNames = varietyNames;
      item.notes = cookInst;
      item.appliedOfferDescription = item.appliedOfferDescription ? item.appliedOfferDescription : "";
      if (item.kitchenId && kitchensUsed.indexOf(item.kitchenId) == -1) {
        kitchensUsed.push(item.kitchenId);
      }
      printDetails.orderItems.push(item);
    });

  console.log('=============', printDetails);
  let isAndroid = false;
  if (window.PrintInterface) {
    isAndroid = true;
    window.PrintInterface.print(JSON.stringify(printDetails));

  }
  if (!isAndroid && window?.chrome?.webview?.postMessage) {
    window.chrome.webview.postMessage(printDetails);
  }

  localStorage.removeItem("ordId");
  //localStorage.removeItem("newOrder");

  return printDetails;
}

// export  const baseURL = 'https://api.menulive.in';
// export const authapi="https://authapi.digitallive24.com";
// export const  authUrl="https://auth.digitallive24.com";
// export  const cmsUrl = 'https://cms.digitallive24.com';

export const timezones = [
  { "label": "Africa/Abidjan" },
  { "label": "Africa/Accra" },
  { "label": "Africa/Algiers" },
  { "label": "Africa/Bissau" },
  { "label": "Africa/Cairo" },
  { "label": "Africa/Casablanca" },
  { "label": "Africa/Ceuta" },
  { "label": "Africa/El_Aaiun" },
  { "label": "Africa/Johannesburg" },
  { "label": "Africa/Juba" },
  { "label": "Africa/Khartoum" },
  { "label": "Africa/Lagos" },
  { "label": "Africa/Maputo" },
  { "label": "Africa/Monrovia" },
  { "label": "Africa/Nairobi" },
  { "label": "Africa/Ndjamena" },
  { "label": "Africa/Sao_Tome" },
  { "label": "Africa/Tripoli" },
  { "label": "Africa/Tunis" },
  { "label": "Africa/Windhoek" },
  { "label": "America/Adak" },
  { "label": "America/Anchorage" },
  { "label": "America/Araguaina" },
  { "label": "America/Argentina/Buenos_Aires" },
  { "label": "America/Argentina/Catamarca" },
  { "label": "America/Argentina/Cordoba" },
  { "label": "America/Argentina/Jujuy" },
  { "label": "America/Argentina/La_Rioja" },
  { "label": "America/Argentina/Mendoza" },
  { "label": "America/Argentina/Rio_Gallegos" },
  { "label": "America/Argentina/Salta" },
  { "label": "America/Argentina/San_Juan" },
  { "label": "America/Argentina/San_Luis" },
  { "label": "America/Argentina/Tucuman" },
  { "label": "America/Argentina/Ushuaia" },
  { "label": "America/Asuncion" },
  { "label": "America/Atikokan" },
  { "label": "America/Bahia" },
  { "label": "America/Bahia_Banderas" },
  { "label": "America/Barbados" },
  { "label": "America/Belem" },
  { "label": "America/Belize" },
  { "label": "America/Blanc‑Sablon" },
  { "label": "America/Boa_Vista" },
  { "label": "America/Bogota" },
  { "label": "America/Boise" },
  { "label": "America/Cambridge_Bay" },
  { "label": "America/Campo_Grande" },
  { "label": "America/Cancun" },
  { "label": "America/Caracas" },
  { "label": "America/Cayenne" },
  { "label": "America/Chicago" },
  { "label": "America/Chihuahua" },
  { "label": "America/Costa_Rica" },
  { "label": "America/Creston" },
  { "label": "America/Cuiaba" },
  { "label": "America/Curacao" },
  { "label": "America/Danmarkshavn" },
  { "label": "America/Dawson" },
  { "label": "America/Dawson_Creek" },
  { "label": "America/Denver" },
  { "label": "America/Detroit" },
  { "label": "America/Edmonton" },
  { "label": "America/Eirunepe" },
  { "label": "America/El_Salvador" },
  { "label": "America/Fort_Nelson" },
  { "label": "America/Fortaleza" },
  { "label": "America/Glace_Bay" },
  { "label": "America/Godthab" },
  { "label": "America/Goose_Bay" },
  { "label": "America/Grand_Turk" },
  { "label": "America/Guatemala" },
  { "label": "America/Guayaquil" },
  { "label": "America/Guyana" },
  { "label": "America/Halifax" },
  { "label": "America/Havana" },
  { "label": "America/Hermosillo" },
  { "label": "America/Indiana/Indianapolis" },
  { "label": "America/Indiana/Knox" },
  { "label": "America/Indiana/Marengo" },
  { "label": "America/Indiana/Petersburg" },
  { "label": "America/Indiana/Tell_City" },
  { "label": "America/Indiana/Vevay" },
  { "label": "America/Indiana/Vincennes" },
  { "label": "America/Indiana/Winamac" },
  { "label": "America/Inuvik" },
  { "label": "America/Iqaluit" },
  { "label": "America/Jamaica" },
  { "label": "America/Juneau" },
  { "label": "America/Kentucky/Louisville" },
  { "label": "America/Kentucky/Monticello" },
  { "label": "America/La_Paz" },
  { "label": "America/Lima" },
  { "label": "America/Los_Angeles" },
  { "label": "America/Lower_Princes" },
  { "label": "America/Maceio" },
  { "label": "America/Managua" },
  { "label": "America/Manaus" },
  { "label": "America/Marigot" },
  { "label": "America/Martinique" },
  { "label": "America/Matamoros" },
  { "label": "America/Mazatlan" },
  { "label": "America/Menominee" },
  { "label": "America/Merida" },
  { "label": "America/Metlakatla" },
  { "label": "America/Mexico_City" },
  { "label": "America/Miquelon" },
  { "label": "America/Moncton" },
  { "label": "America/Monterrey" },
  { "label": "America/Montevideo" },
  { "label": "America/Montreal" },
  { "label": "America/Nassau" },
  { "label": "America/New_York" },
  { "label": "America/Nipigon" },
  { "label": "America/Nome" },
  { "label": "America/Noronha" },
  { "label": "America/North_Dakota/Beulah" },
  { "label": "America/North_Dakota/Center" },
  { "label": "America/North_Dakota/New_Salem" },
  { "label": "America/Ojinaga" },
  { "label": "America/Panama" },
  { "label": "America/Pangnirtung" },
  { "label": "America/Paramaribo" },
  { "label": "America/Phoenix" },
  { "label": "America/Port‑au‑Prince" },
  { "label": "America/Port_of_Spain" },
  { "label": "America/Porto_Velho" },
  { "label": "America/Puerto_Rico" },
  { "label": "America/Rainy_River" },
  { "label": "America/Rankin_Inlet" },
  { "label": "America/Recife" },
  { "label": "America/Regina" },
  { "label": "America/Resolute" },
  { "label": "America/Rio_Branco" },
  { "label": "America/Santarem" },
  { "label": "America/Santiago" },
  { "label": "America/Santo_Domingo" },
  { "label": "America/Sao_Paulo" },
  { "label": "America/Scoresbysund" },
  { "label": "America/Shiprock" },
  { "label": "America/Sitka" },
  { "label": "America/St_Johns" },
  { "label": "America/Swift_Current" },
  { "label": "America/Tegucigalpa" },
  { "label": "America/Thule" },
  { "label": "America/Thunder_Bay" },
  { "label": "America/Tijuana" },
  { "label": "America/Toronto" },
  { "label": "America/Vancouver" },
  { "label": "America/Whitehorse" },
  { "label": "America/Winnipeg" },
  { "label": "America/Yakutat" },
  { "label": "America/Yellowknife" },
  { "label": "Asia/Almaty" },
  { "label": "Asia/Amman" },
  { "label": "Asia/Anadyr" },
  { "label": "Asia/Aqtau" },
  { "label": "Asia/Aqtobe" },
  { "label": "Asia/Arkhangelsk" },
  { "label": "Asia/Ashgabat" },
  { "label": "Asia/Atyrau" },
  { "label": "Asia/Baghdad" },
  { "label": "Asia/Bahrain" },
  { "label": "Asia/Baku" },
  { "label": "Asia/Bangkok" },
  { "label": "Asia/Barnaul" },
  { "label": "Asia/Beirut" },
  { "label": "Asia/Bishkek" },
  { "label": "Asia/Brunei" },
  { "label": "Asia/Chita" },
  { "label": "Asia/Choibalsan" },
  { "label": "Asia/Chongqing" },
  { "label": "Asia/Colombo" },
  { "label": "Asia/Damascus" },
  { "label": "Asia/Dhaka" },
  { "label": "Asia/Dili" },
  { "label": "Asia/Dubai" },
  { "label": "Asia/Dushanbe" },
  { "label": "Asia/Famagusta" },
  { "label": "Asia/Gaza" },
  { "label": "Asia/Hebron" },
  { "label": "Asia/Ho_Chi_Minh" },
  { "label": "Asia/Hong_Kong" },
  { "label": "Asia/Hovd" },
  { "label": "Asia/Irkutsk" },
  { "label": "Asia/Jakarta" },
  { "label": "Asia/Jayapura" },
  { "label": "Asia/Jerusalem" },
  { "label": "Asia/Kabul" },
  { "label": "Asia/Kamchatka" },
  { "label": "Asia/Karachi" },
  { "label": "Asia/Kashgar" },
  { "label": "Asia/Kathmandu" },
  { "label": "Asia/Khandyga" },
  { "label": "Asia/Kolkata" },
  { "label": "Asia/Krasnoyarsk" },
  { "label": "Asia/Kuala_Lumpur" },
  { "label": "Asia/Kuching" },
  { "label": "Asia/Kuwait" },
  { "label": "Asia/Macau" },
  { "label": "Asia/Magadan" },
  { "label": "Asia/Makassar" },
  { "label": "Asia/Manila" },
  { "label": "Asia/Muscat" },
  { "label": "Asia/Nicosia" },
  { "label": "Asia/Novokuznetsk" },
  { "label": "Asia/Novosibirsk" },
  { "label": "Asia/Omsk" },
  { "label": "Asia/Oral" },
  { "label": "Asia/Phnom_Penh" },
  { "label": "Asia/Pontianak" },
  { "label": "Asia/Pyongyang" },
  { "label": "Asia/Qatar" },
  { "label": "Asia/Qostanay" },
  { "label": "Asia/Qyzylorda" },
  { "label": "Asia/Riyadh" },
  { "label": "Asia/Sakhalin" },
  { "label": "Asia/Samarkand" },
  { "label": "Asia/Seoul" },
  { "label": "Asia/Shanghai" },
  { "label": "Asia/Singapore" },
  { "label": "Asia/Srednekolymsk" },
  { "label": "Asia/Taipei" },
  { "label": "Asia/Tashkent" },
  { "label": "Asia/Tbilisi" },
  { "label": "Asia/Tehran" },
  { "label": "Asia/Thimphu" },
  { "label": "Asia/Tokyo" },
  { "label": "Asia/Tomsk" },
  { "label": "Asia/Ulaanbaatar" },
  { "label": "Asia/Urumqi" },
  { "label": "Asia/Ust‑Nera" },
  { "label": "Asia/Vientiane" },
  { "label": "Asia/Vladivostok" },
  { "label": "Asia/Yakutsk" },
  { "label": "Asia/Yangon" },
  { "label": "Asia/Yekaterinburg" },
  { "label": "Asia/Yerevan" },
  { "label": "Etc/GMT" },
  { "label": "Etc/GMT+0" },
  { "label": "Etc/GMT+1" },
  { "label": "Etc/GMT+2" },
  { "label": "Etc/GMT+3" },
  { "label": "Etc/GMT‑1" },
  { "label": "Etc/UTC" },
  { "label": "Pacific/Auckland" },
  { "label": "Pacific/Fiji" },
  { "label": "Pacific/Enderbury" },
  { "label": "Pacific/Apia" },
  { "label": "Pacific/Chatham" },
  { "label": "Pacific/Easter" },
  { "label": "Pacific/Guadalcanal" },
  { "label": "Pacific/Guam" },
  { "label": "Pacific/Honolulu" },
  { "label": "Pacific/Kiritimati" },
  { "label": "Pacific/Midway" },
  { "label": "Pacific/Niue" },
  { "label": "Pacific/Pitcairn" },
  { "label": "Pacific/Tahiti" },
  { "label": "Pacific/Wallis" },
  { "label": "UTC" }
]
  ;


